@if (filter.withSearch) {
  <div
    class="mb-1">
    <app-search-bar [settings]="searchSettings"
    (search)="onSearch($event)"></app-search-bar>
  </div>
}
@if (filter.withPagination) {
  <app-loader [loaderId]="loaderId"
    [fullPage]="false">
    <cdk-virtual-scroll-viewport [itemSize]="CDK_ITEM"
      [minBufferPx]="CDK_HEIGHT"
      [maxBufferPx]="CDK_HEIGHT + CDK_ITEM"
                                 [style.height.px]="filterOptions?.value?.length ? filterOptions.value.length * CDK_ITEM + ENDDATA_HEIGHT >
      CDK_HEIGHT ? CDK_HEIGHT : filterOptions.value.length * CDK_ITEM + ENDDATA_HEIGHT : null"
      class="viewport overflow mini">
      <div [uidGenerator]="'checkbox-'"
        *cdkVirtualFor="let item of filterOptions | async; trackBy: trackByIdx ; let index = index"
        class="item custom-control custom-checkbox">
        <input class="custom-control-input"
          type="checkbox"
          [value]="item.value"
          [checked]="item.checked"
          (change)="onChangeCheckBox(filter, item)" />
          <label style="max-width: 250px;"
            class="custom-control-label truncate"
          title="{{item.text | translate}}">{{item.text | translate}}</label>
        </div>
        @if (totalCount && totalCount === filterOptions.value.length) {
          <div
            class="d-flex justify-content-center"
            [style.height.px]="ENDDATA_HEIGHT">
            <small>End data</small>
          </div>
        }
      </cdk-virtual-scroll-viewport>
      <div style="position: absolute; top:0; left:0; width:100%; height:100%; pointer-events:none"></div>
    </app-loader>
  }

  @if (!filter.withPagination) {
    <div
      class="radio-max-height overflow mini">
      @for (item of filterOptions | async; track item) {
        <div [uidGenerator]="'checkbox-'"
          class="custom-control custom-checkbox margin-bottom-small">
          <input class="custom-control-input"
            type="checkbox"
            [value]="item.value"
            [checked]="item.checked"
            (change)="onChangeCheckBox(filter, item)" />
            <label style="max-width: 250px;"
              class="custom-control-label truncate"
              title="{{item.text | translate}}">{{item.text
            | translate}}</label>
          </div>
        }
      </div>
    }
